import { Box, IconButton, Tooltip } from '@mui/material'
import Button from '@mui/material/Button'
import React, { useMemo, useState } from 'react'
import * as Yup from 'yup'
import { Currency } from '../../atoms/numberFormatCustom'
import { exemptLimit } from '../../calcs/incomeTaxCalculation'
import { ResultTable } from '../../molecules/resultTable'
import HelpOutline from '@mui/icons-material/HelpOutline';
import { ConversionDialog } from '../../molecules/conversionDialog'
import { ExceptDescription } from '../../molecules/exceptDescription'
import * as S from './styles.js'
import Slider from '@mui/material/Slider'
import { ResultDescription } from '../../molecules/resultDescription'
import { ResultSummary } from '../../molecules/resultSummary'
import { process } from '../../calcs/fiscalCalculation'

const SignupSchema = Yup.object().shape({
	investment: Yup.string().required('Preencha este campo.'),
})

const fields = [
	'alimonyYearlyExpenses',
	'averageMedicalYearlyExpenses',
	'grossIncome',
	'ownEducationYearlyExpenses',
	'previdencyYearlyContribution']

export function Result ({
	data,
	setData,
	setStepState,
	stepState,
}) {
	const numberedData = fields.reduce((p, c) => {
		p[c] = Number(p[c])
		return p
	}, data)

	const [pgblContribution, setPgblContribution] = useState(
		numberedData.previdencyYearlyContribution)

	const result = useMemo(() => process({
		...numberedData,
		previdencyYearlyContribution: pgblContribution,
	}), [pgblContribution]);

	const [ConversionDialogOpen, setConversionDialogOpen] = React.useState(false)

	const handleClickConversionDialogOpen = () => {
		setConversionDialogOpen(true)
	}

	const handleCloseConversionDialog = () => {
		setConversionDialogOpen(false)
	}

	return (<>
		{ numberedData.grossIncome > exemptLimit ?
		<S.Container>
			<S.Form>
				<S.Row>
					<S.Text>Valor da contribuição previdênciaria PGBL anual: </S.Text>
					<S.UndelinedNumber>{`R$${Currency(pgblContribution)}`}</S.UndelinedNumber>
					<Box style={{color: "#6202EE"}}>
						<Tooltip title="Permitido valor até de abatimento com PGBL. (12% da sua renda bruta)" placement="top" arrow={true}>
							<HelpOutline />
						</Tooltip>
					</Box>
				</S.Row>
				<Slider
					id={'previdencyYearlyContribution'}
					name={'previdencyYearlyContribution'}
					value={pgblContribution}
					onChange={(e, newValue) => {
						console.log(newValue)
						setPgblContribution(Number(newValue))
					}}
					aria-labelledby="input-slider"
					min={0}
					step={100}
					max={result.withSupplementaryPensionMaximum.supplementaryPensionContribution}
				/>
				<Box fontSize={24} pt={2} pb={4}>
					<strong>Resumo dos cálculos em R$</strong>
				</Box>
				<ResultTable data={result} input={data}/>
			</S.Form>

			<div>
				<ResultDescription initialResult={result}
													 handleClickConversionDialogOpen={handleClickConversionDialogOpen}/>
				<ResultSummary initialResult={result}
											 handleClickConversionDialogOpen={handleClickConversionDialogOpen}/>
			</div>

		</S.Container> :
			<Box>
				<ExceptDescription initialResult={result}
													 handleClickConversionDialogOpen={handleClickConversionDialogOpen}/>
			</Box>
		}
		<ConversionDialog data={data} open={ConversionDialogOpen} initialStep={2}
											handleCloseDialog={handleCloseConversionDialog}/>
		<S.Footer>
			<S.Hr/>
			<Button onClick={() => {
				if(window.mixpanel) {
					window.mixpanel.track('Back step 2 button')
				}
				setStepState({
					...stepState,
					index: 1,
				})
			}} variant="contained" color="secondary">PASSO ANTERIOR</Button>
		</S.Footer>
	</>)
}
